export default __webpack_public_path__ + "static/media/sportsbet_au.9020d96b.png";